"use client";

import CloseIcon from "@/assets/icons/close.svg?react";
import { LensBundleOverLay } from "@/common/lib/types";
import { Carousel } from "@/components/ui/carousel/Carousel";
import Modal from "@/components/ui/modal_new/Modal";
import { useMediaQuery } from "@/hooks/useMediaQuery";
import Image from "next/image";
import ArrowLeftIcon from "@/assets/icons/arrow-left.svg?react";
import ArrowRightIcon from "@/assets/icons/arrow-right.svg?react";
import { getCloudinaryURL } from "@/utils/cloudinary";
import NoImageSrc from "@/assets/images/no_image.svg";

interface IProps {
  open: boolean;
  onClose: () => void;
  lensInfo: LensBundleOverLay;
}

const LensInfoOverlay = ({ open, onClose, lensInfo }: IProps) => {
  const isSmallScreen = useMediaQuery("(max-width: 640px)", {
    defaultValue: false,
    initializeWithValue: true,
  });

  console.log({ lensInfo });

  return (
    <Modal
      isOpen={open}
      onClose={onClose}
      slots={{
        close: { visible: false },
        container: { className: "max-w-[50rem] w-full p-4" },
        root: { className: "px-0 sm:px-4 items-end sm:items-center" },
      }}
    >
      <div className="flex items-center justify-between px-6 py-5">
        <h1>{lensInfo?.overlayTitle}</h1>
        <button onClick={onClose}>
          <CloseIcon className="h-3 w-3" />
        </button>
      </div>
      <div className="pb-8">
        <Carousel
          autoPlay={{ playOnInit: false, active: false }}
          controls={{
            distance: "5px",
            left: {
              top: "60%",
              content: (
                <button className="hidden bg-[#66666617] p-2 md:block">
                  <ArrowLeftIcon />
                </button>
              ),
            },
            right: {
              top: "60%",
              content: (
                <div className="hidden bg-[#66666617] p-2 md:block">
                  <ArrowRightIcon />
                </div>
              ),
            },
          }}
          slides={(lensInfo?.items || []).map((v) => ({
            slideClasses: "basis-full",
            content: (
              <div className="flex flex-col gap-11">
                <Image
                  alt={v.key}
                  width={200}
                  height={290}
                  className="h-full w-full"
                  src={
                    isSmallScreen
                      ? v.mobileMedia
                        ? getCloudinaryURL(v.mobileMedia)
                        : NoImageSrc
                      : v.desktopMedia
                        ? getCloudinaryURL(v.desktopMedia)
                        : NoImageSrc
                  }
                />
                <div dangerouslySetInnerHTML={{ __html: v.content }} className="px-12 text-sm" />
              </div>
            ),
          }))}
        />
      </div>
    </Modal>
  );
};

export default LensInfoOverlay;
